import { useCurrentAccount } from '@mysten/dapp-kit-react'

import { useViewAsWallet } from 'contexts/ViewAsWalletContext'

export const useCurrentWalletAddress = () => {
  const currentAccount = useCurrentAccount()
  const { viewAsWalletAddress } = useViewAsWallet()

  if (viewAsWalletAddress) {
    return viewAsWalletAddress
  }

  return currentAccount?.address
}
